var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.title,
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _c('CommonMode', {
    attrs: {
      "type": _vm.type,
      "integration": _vm.integration
    },
    on: {
      "save-info": _vm.saveInfo
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }